function render() {
    const merkzettelLimitHinweis = document.querySelector('[data-template="merkzettel-limit-hinweis"]').innerHTML;
    document.body.insertAdjacentHTML('beforeend', merkzettelLimitHinweis);
};

render();

class MerkzettelLimitHinweis extends HTMLElement {
    static get tag() {
        return "merkzettel-limit-hinweis";
    }

    static {
        if (!customElements.get(MerkzettelLimitHinweis.tag)) {
            customElements.define(MerkzettelLimitHinweis.tag, MerkzettelLimitHinweis);
        }
    }
    
    constructor() {
        super();
        this.events = ["merkzettel-limit-hinweis"];
        this.addListener();
    }
    
    connectedCallback() {
        this.dialog = this.querySelector("dialog");
        this.initLoginUrl("[interaction=konto-anlegen]");
        this.initLoginUrl("[interaction=anmelden]");
    }

    disconnectedCallback() {
        this.removeListener();
    }

    addListener() {
        for (const event of this.events) {
            document.addEventListener(event, this);
        }
    }

    removeListener() {
        for (const event of this.events) {
            document.removeEventListener(event, this);
        }
    }

    handleEvent(event) {
        const { type } = event;
        if (type === "merkzettel-limit-hinweis") {
            this.dialog.showModal();
        }
    }

    initLoginUrl(selector) {
        const target = this.querySelector(selector);
        const href = target.href;
        target.href = href + "?source=" + encodeURIComponent(window.location.pathname + window.location.search);
    }
}
